import { Model } from "vue-mc";

export class Tipo extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , canales: ""
      , localizacion: false
      , contacto: false
      , adicional: false
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , canales: (canales) => canales
      , localizacion: (localizacion) => localizacion
      , contacto: (contacto) => contacto
      , adicional: (adicional) => adicional
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/tipo.js